import './main.css';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

import { useNavigate } from "react-router-dom";
import banner from "./banner.png"
import banner2 from "./banner2.png"

import { Carousel } from 'antd';
import logo from '../../images/logo.png'

function SignupTwo() {

    // let scopes = "instagram_basic,instagram_content_publish,instagram_manage_comments,instagram_manage_insights,pages_show_list,pages_read_engagement"
    let scopes = "business_basic,business_content_publish,business_manage_comments,business_manage_messages"
    // let appId = "433149449449290"
    let appId = "996086435858506"
    let redirectURL = "https://app.instantdm.com/fb-rdr"
    let url = `https://www.instagram.com/oauth/authorize?client_id=${appId}&redirect_uri=${redirectURL}&response_type=code&scope=${scopes}`



    const search = window.location.search;
    const urlParams = new URLSearchParams(search);
    const show_ig_connect = urlParams.get('show_ig_connect') || false ;


    const [showHelp, setShowHelp] = useState(false);

    useEffect(() => {
      const visitedBefore = localStorage.getItem('visitedBefore');
      if (visitedBefore === 'true') {
        setShowHelp(true);
      } else {
        localStorage.setItem('visitedBefore', 'true');
      }
    }, []);

    const routeChange = () =>{ 
        window.location.assign(url);
    }

    const fbRouteChange = () => {
        scopes = "instagram_basic,email,instagram_manage_comments,pages_show_list,business_management,instagram_manage_messages,pages_read_engagement,pages_manage_metadata"
        appId = "433149449449290"
        redirectURL = "https://app.instantdm.com/fb-api-rdr"
        let extras = '{"setup":{"channel":"IG_API_ONBOARDING"}}'
        url = `https://www.facebook.com/v20.0/dialog/oauth?client_id=${appId}&display=page&redirect_uri=${redirectURL}&response_type=token&scope=${scopes}`
        window.location.assign(url);
    }

    return(
        <div className='account-setup'>
            <img src={logo} style={{ height: '50px' , width : '150px' }} />
            <div className='core-div'>
                <div className='flex-space-between'>
                    <div className='header-content'>
                        <h1>Connect your IG account</h1>
                        <p>To Proceed further, please connect your IG account.</p>
                    </div>
                    <div className='button-left desktop'>
                    
                        <a target='_blank' href='https://instagram.com/instant.dm' className='help'>Watch Video</a>
                         {showHelp && <a target='_blank' href='https://instagram.com/instant.dm' className='help'>Need Help?</a>}
                         <div onClick={() => show_ig_connect == false ? fbRouteChange() : routeChange()}  className='connect-fb'>Connect your IG Account</div>
                    </div>
                
                </div>

                <h3>Steps to connect your IG Account</h3>
                
                {show_ig_connect == false ? 
                <div className='steps'>
                    
                    <div className='step'>
                        <img src="https://public-bucket-v3.s3.ap-south-1.amazonaws.com/steps-idm/step1.png"/>
                    </div>
                    <div className='step'>
                        <img src="https://public-bucket-v3.s3.ap-south-1.amazonaws.com/steps-idm/step2.png"/>
                    </div>
                    <div className='step'>
                        <img src="https://public-bucket-v3.s3.ap-south-1.amazonaws.com/steps-idm/step3.png"/>
                    </div>
                    <div className='step'>
                        <img src="https://public-bucket-v3.s3.ap-south-1.amazonaws.com/steps-idm/step4.png"/>
                    </div>
                    <div className='step'>
                        <img src="https://public-bucket-v3.s3.ap-south-1.amazonaws.com/steps-idm/step5.png"/>
                    </div>
                    <div className='step'>
                        <img src="https://public-bucket-v3.s3.ap-south-1.amazonaws.com/steps-idm/step6.png"/>
                    </div>
                </div> 
                : 
                <div className='steps'>
                    
                <div className='step'>
                    <img src="https://public-bucket-v3.s3.ap-south-1.amazonaws.com/steps-idm/igstep1.png"/>
                </div>
                <div className='step'>
                    <img src="https://public-bucket-v3.s3.ap-south-1.amazonaws.com/steps-idm/igstep2.png"/>
                </div>
                <div className='step'>
                    <img src="https://public-bucket-v3.s3.ap-south-1.amazonaws.com/steps-idm/igstep3.png"/>
                </div>
            </div> 
                }
            
            <div className='button-row mobile'>
                    
                    <div onClick={() => show_ig_connect == false ? fbRouteChange() : routeChange()}  className='connect-fb'>Connect your IG Account</div>
                    <a target='_blank' href='https://instagram.com/instant.dm' className='help'>Watch Video</a>
                    {showHelp && <a target='_blank' href='https://instagram.com/instant.dm' className='help'>Need Help?</a>}
            </div>
                
            </div>
        </div>
    )

}

export default SignupTwo;


{/* <div className='signup'>
            <div className='left-side' style={{overflow:'hidden'}}>
            <Carousel autoplay adaptiveHeight>
                <div>
                <img src={banner} style={{height:'100%' , width:'100%', backgroundColor:'pink'}} />
                </div>
                <div>
                <img src={banner2} style={{height:'100%' , width:'100%', backgroundColor:'red'}} />
                </div>
            </Carousel>
            </div>
            <div className='right-side'>
                <div className='singup-box'>
                    <p className='product-name'>Instant DM</p>
                    <h3 className='hero-text' >One more step <br/> Connect With Instagram</h3> 
                    
                    
                    {show_ig_connect == false ? <div className='fb-btn' style={{backgroundColor:'blue'}} onClick={() => fbRouteChange() }>Continue With Facebook</div> :
                    <div className='fb-btn'  onClick={() => routeChange() }>Continue With Instagram</div>
                    }
                    
                   
                    
                </div>
                
            </div>
        </div> */}